import Chip from "@web-ui/components/Chip";
import Icon from "@web-ui/components/Icon";
import { badgeFor, type Availability, type StatusTone } from "@/publishing/status";

/**
 * The one status badge (section 3), used wherever an item appears: lists, the editor's header,
 * pickers, Home. The word is in the chip's neutral ink, so it reads at full contrast in both
 * themes; the fixed status tone colours the icon beside it (never the brand accent).
 */
const TONE_FILL: Record<StatusTone, string> = {
  neutral: "fill-t-tertiary",
  positive: "fill-positive-stroke",
  warning: "fill-warning",
  critical: "fill-critical",
};

export function StatusBadge({ state, availability, size = "sm" }: { state: string | undefined; availability?: Availability | null; size?: "sm" | "md" }) {
  const badge = badgeFor(state, availability);
  return (
    <Chip size={size}>
      <span className="inline-flex items-center gap-1" title={badge.meaning} data-state={badge.state}>
        <Icon name={badge.icon} size={4} className={TONE_FILL[badge.tone]} />
        {badge.label}
      </span>
    </Chip>
  );
}
